export enum TableDataTab {
  Public = 'public_template',
  Game = 'game_template',
  Share = 'share',
  Dashboard = 'dashboard',
  MyDashboard = 'my_dashboard'
}